export default function DisclaimerBanner() {
  return (
    <div className="p-3 bg-white/50 rounded-[14px] border border-gray-200/25">
      <p className="text-[10.5px] text-app-subtle text-center leading-relaxed font-semibold">
        PawCare est un outil d'aide, pas un diagnostic medical officiel.
        <br />
        En cas d'urgence, contactez un veterinaire immediatement. {"\uD83E\uDE7A"}
      </p>
    </div>
  );
}
